import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";

import { useNavigate } from "react-router";
import {
	getAllProductsError,
	getAllProductsStatus,
	getProducts,
	selectGetAllProductsArray,
} from "../../redux/ProductsSlice";
import LoadingError from "../Error/LoadingError";
import Box from "@mui/material/Box";
import {DataGridPro, GridToolbar} from "@mui/x-data-grid-pro";
import {NoRowsDialog} from "../Inputs/NoRowsDialog";

function ProductSummaryTable() {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const products = useSelector(selectGetAllProductsArray);
	const productsStatus = useSelector(getAllProductsStatus);
	const productsError = useSelector(getAllProductsError);

	useEffect(() => {
		if (productsStatus === "idle") {
			dispatch(getProducts());
		}
	}, [dispatch, productsStatus]);

	const handleRowClick = (event) => {
		navigate(`/products/${event.id}`);
	};

	const columns = [
		{ field: 'name', headerName: 'Name', headerClassName: 'products-theme--header', cellClassName: 'hyperlink', width: 225 },
		{ field: 'productType', headerName: 'Type', headerClassName: 'products-theme--header', width: 75 },
		{ field: 'businessCode', headerName: 'Code', headerClassName: 'products-theme--header', width: 100 },
		{ field: 'description', headerName: 'Description', headerClassName: 'products-theme--header', width: 150 },
		{ field: 'createdBy', headerName: 'Created By', headerClassName: 'products-theme--header', width: 150 },
		{ field: 'createdAt', headerName: 'Created At', headerClassName: 'products-theme--header', width: 170 }
	];

	return (
		<Box sx={{
			display: 'flex',
			flexDirection: 'column',
			minHeight: products.length === 0 ? '350px' : '1000px',
			maxHeight: '1200px',
			"& .MuiDataGrid-row:hover": {
				cursor: "pointer",
			},
			'& .products-theme--header': {
				color: 'white',
			}
		}}
		>
			<DataGridPro
				checkboxSelection
				initialState={{
					density: 'compact',
				}}
				disableRowSelectionOnClick
				columns={columns}
				onRowClick={handleRowClick}
				rows={!productsError ? products : []}
				loading={productsStatus === 'loading'}
				slots={{ 
					toolbar: !productsError && GridToolbar,
                    noRowsOverlay: () => !!productsError ? <LoadingError component={"products"} /> : <NoRowsDialog path={"products"} domain={"Product"} />
				}}
				slotProps={{
					toolbar: {
						showQuickFilter: true,
					},
					loadingOverlay: {
						variant: 'skeleton',
						noRowsVariant: 'skeleton',
					},
				}}
			/>
		</Box>
	)
}

export default ProductSummaryTable;